import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";
import { LOGO_URL } from "../lib/api";

export default function Navbar() {
  const { count, setOpen } = useCart();
  const navigate = useNavigate();

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 bg-stone-50/90 backdrop-blur border-b border-stone-200"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-3 flex items-center justify-between gap-4">
        <button
          data-testid="nav-logo"
          onClick={() => navigate("/")}
          className="flex items-center gap-3 group"
        >
          <img
            src={LOGO_URL}
            alt="Bidoudou50.fr"
            className="w-11 h-11 object-cover rounded-sm border border-stone-200"
          />
          <span className="font-serif text-2xl tracking-tight text-stone-900 group-hover:text-orange-800 transition-colors">
            Bidoudou<span className="text-orange-700">50</span>
            <span className="text-stone-400 text-base">.fr</span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-7 text-sm uppercase tracking-[0.18em] text-stone-600">
          <a href="/#produits" data-testid="nav-products" className="hover:text-orange-800 transition-colors">Boutique</a>
          <a href="/#categories" data-testid="nav-categories" className="hover:text-orange-800 transition-colors">Catégories</a>
          <a href="/#avis" data-testid="nav-reviews" className="hover:text-orange-800 transition-colors">Avis</a>
          <a href="/#contact" data-testid="nav-contact" className="hover:text-orange-800 transition-colors">Contact</a>
          <Link to="/admin/login" data-testid="nav-admin" className="hover:text-orange-800 transition-colors">Admin</Link>
        </nav>

        <button
          data-testid="open-cart-button"
          onClick={() => setOpen(true)}
          className="relative inline-flex items-center gap-2 px-4 py-2 bg-stone-900 hover:bg-stone-800 text-white rounded-sm transition-colors"
        >
          <ShoppingBag size={18} />
          <span className="text-sm font-medium hidden sm:inline">Panier</span>
          {count > 0 && (
            <span
              data-testid="cart-count-badge"
              className="absolute -top-2 -right-2 w-5 h-5 flex items-center justify-center text-xs font-bold bg-orange-700 text-white rounded-full"
            >
              {count}
            </span>
          )}
        </button>
      </div>
    </header>
  );
}
